import producer from 'immer';
import { UPDATE_USER_AUTHORIZATION } from './types';

export const initialState = {
  userPhotographer: {
    allowed: false,
    isBetaTester: false,
  },
};

const updateUserAuthorization = (state, { authorization }) =>
  ({
    ...state,
    userPhotographer: authorization,
  });

export const authorizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER_AUTHORIZATION:
      return updateUserAuthorization(state, action);
    default:
      return state;
  }
};

export default producer(authorizationReducer);
